import { render, staticRenderFns } from "./processPage.vue?vue&type=template&id=5b2c5e2a&scoped=true&"
import script from "./processPage.vue?vue&type=script&lang=js&"
export * from "./processPage.vue?vue&type=script&lang=js&"
import style0 from "./processPage.vue?vue&type=style&index=0&id=5b2c5e2a&lang=less&scoped=true&"
import style1 from "./processPage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c5e2a",
  null
  
)

export default component.exports